export const mediaQuery ={
    tablet: "@media(max-width: 900px)",
    mobile: "@media(max-width: 450px)"
}